<template>
  <div class="ack workspace-grid workspace">
    <div class="list">
      <h2>Integrated Methods, Tools and Databases</h2>
      <p>
        BY USING THE ABOVE-NAMED SERVICE OR ITS RELATED DOCUMENTATION
        (COLLECTIVELY, THE "SERVICE"), YOU ACKNOWLEDGE THAT YOU HAVE READ ALL OF
        THE TERMS AND CONDITIONS OF THIS AGREEMENT, UNDERSTAND THEM, AND AGREE
        TO BE BOUND BY THEM. WE RECOMMEND THAT YOU PRINT A COPY OF THIS
        AGREEMENT FOR YOUR RECORDS.
      </p>
      <p>
        IF YOU DO NOT AGREE TO ALL OF THE TERMS OF THIS AGREEMENT, YOU MUST NOT
        USE THE SERVICE.
      </p>
      <p>
        YOU HEREBY REPRESENT AND WARRANT THAT YOU HAVE THE LEGAL AUTHORITY TO
        BIND THE ORGANIZATION NAMED IN YOUR REGISTRATION FORM, IF ANY, AND IF
        SUCH AN ORGANIZATION IS NAMED, SUCH ORGANIZATION SHALL BE DEEMED TO BE
        "YOU" FOR THE PURPOSE OF THIS AGREEMENT. IF NO SUCH ORGANIZATION IS
        NAMED, THEN "YOU" SHALL REFER TO YOU INDIVIDUALLY.
      </p>
      <p>
        THIS SERVICE LICENSE AGREEMENT IS ENTERED INTO BY AND BETWEEN THE
        LOSCHMIDT LABORATORIES, DEPARTMENT OF EXPERIMENTAL BIOLOGY AND RECETOX
        FACULTY OF SCIENCE, MASARYK UNIVERSITY, KOTLARSKA 267/2, 611 37 BRNO,
        CZECH REPUBLIC (HEREINAFTER "LL") AND THE "LICENSEE". WHEREAS LL HAS THE
        RIGHT TO LICENSE ALL COPYRIGHTS AND OTHER PROPERTY RIGHTS IN THE
        LICENSED SERVICE IDENTIFIED AS THE SERVICE IS MAINTAINED AND DEVELOPED
        BY LL AND LL DESIRES TO LICENSE THE SERVICE SO THAT IT BECOMES AVAILABLE
        FOR PUBLIC USE AND BENEFIT.
      </p>
      <h2>License Grant</h2>
      <p>
        LL grants You a non-exclusive and non-transferable license to use the
        Service. LL reserves the right to make corrections, improvements or
        enhancements to the Service without notice to You and without obligation
        to furnish the said corrections, improvements or enhancements to You.
      </p>
      <h2>Restrictions</h2>
      <p>
        You will not (i) use, or cause or permit the use of, the Service in
        whole or in part for any purpose other than as permitted under this
        Agreement; (ii) sell, lease, sublicense or otherwise transfer rights to
        the output of the Service to any third party; (iii) modify or create any
        derivative works of the Service, including translation or localization;
        or (iv) remove or alter any trademark, logo, copyright or other
        proprietary notices, legends, symbols or labels in the Service and its
        output.
      </p>
      <h2>Term and Termination</h2>
      <p>
        The term of this Agreement shall continue until terminated. This
        Agreement, and the rights granted hereunder, will terminate
        automatically, and without any further notice from or action by LL, if
        You fail to comply with any obligation set forth herein. Upon
        termination, You must immediately cease use of the Service. LL shall
        have the right to disable electronically Your unauthorized use of the
        Service and resort to other "self help" measures LL deems appropriate.
      </p>
      <h2>No Obligation to Support</h2>
      <p>
        It is understood and agreed that LL will provide no maintenance or
        installation services of any kind, error corrections, bug fixes,
        patches, updates or other modifications hereunder. In the event that LL,
        at its sole option, provides updates, error corrections, bug fixes,
        patches, modifications, consultation or end-user support of any kind.
      </p>
      <h2>Proprietary rights</h2>
      <p>
        Title to the Service copyrights, trademarks and all other intellectual
        property rights applicable thereto, shall at all times remain solely and
        exclusively with LL and its affiliates, and You shall not take any
        action inconsistent with such ownership. Any rights not expressly
        granted herein are reserved to LL and its suppliers. You will not use or
        display any trademark, trade name, insignia, or symbols of LL, its
        faculties or departments, or any variation or combination thereof, or
        the name of any trustee, faculty member, other employee, or student of
        LL, for any purpose whatsoever without LL's prior written consent.
      </p>
      <h2>NO WARRANTY</h2>
      <p>
        TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, LL DISCLAIMS ALL
        WARRANTIES AND CONDITIONS, EITHER EXPRESS OR IMPLIED, WITH RESPECT TO
        THE SERVICE, INCLUDING BUT NOT LIMITED TO ALL IMPLIED WARRANTIES AND
        CONDITIONS OF MERCHANTABILITY, TITLE, FITNESS, ADEQUACY OR SUITABILITY
        FOR A PARTICULAR PURPOSE, USE OR RESULT, OR ARISING FROM A COURSE OF
        DEALING, USAGE OR TRADE PRACTICE, AND ANY WARRANTIES OF FREEDOM FROM
        INFRINGEMENT OF ANY DOMESTIC OR FOREIGN PATENTS, COPYRIGHTS, TRADE
        SECRETS OR OTHER PROPRIETARY RIGHTS OF ANY PARTY. LL SPECIFICALLY
        DISCLAIMS ANY WARRANTY THAT THE FUNCTIONS CONTAINED IN THE SERVICE WILL
        MEET YOUR REQUIREMENTS OR WILL OPERATE IN COMBINATIONS OR IN A MANNER
        SELECTED FOR USE BY YOU, OR THAT THE OPERATION OF THE LICENSED SOFTWARE
        WILL BE UNINTERRUPTED OR ERROR FREE.
      </p>
      <h2>LIMITATION OF LIABILITY</h2>
      <p>
        IN NO EVENT SHALL LL BE LIABLE TO YOU FOR ANY DAMAGES RESULTING FROM
        LOSS OF DATA, LOST PROFITS, LOSS OF USE OF EQUIPMENT OR LOST CONTRACTS
        OR FOR ANY SPECIAL, INDIRECT, INCIDENTAL, PUNITIVE, EXEMPLARY OR
        CONSEQUENTIAL DAMAGES IN ANY WAY ARISING OUT OF OR IN CONNECTION WITH
        THE USE OR PERFORMANCE OF THE SERVICE OR RELATING TO THIS AGREEMENT,
        HOWEVER CAUSED, EVEN IF LL HAS BEEN MADE AWARE OF THE POSSIBILITY OF
        SUCH DAMAGES.
      </p>
      <h2>Assignment</h2>
      <p>
        Neither this Agreement nor any rights, obligations or licenses granted
        hereunder may be assigned or delegated by You without the prior written
        consent of LL. This Agreement shall inure to the benefit of the parties
        and their permitted successors and assigns.
      </p>
      <h2>Governing Law; Jurisdiction and Venue</h2>
      <p>
        This Agreement shall be governed by Czech Republic law applicable to
        agreements made and to be fully performed in Czech Republic, without
        reference to the conflict of laws principles of any jurisdiction.
      </p>
      <h2>Severability</h2>
      <p>
        If any provision of this Agreement shall be held by a court of competent
        jurisdiction to be illegal, invalid or unenforceable, the remaining
        provisions shall remain in full force and effect.
      </p>
      <h2>Miscellaneous</h2>
      <p>
        (a) This Agreement and its exhibits contain the entire understanding and
        agreement between the parties respecting the subject matter hereof. (b)
        This Agreement may not be supplemented, modified, amended, released or
        discharged except by an instrument in writing signed by each party's
        duly authorized representative. (c) All captions and headings in this
        Agreement are for purposes of convenience only and shall not affect the
        construction or interpretation of any of its provisions. (d) Any waiver
        by either party of any default or breach hereunder shall not constitute
        a waiver of any provision of this Agreement or of any subsequent default
        or breach of the same or a different kind. (e) This Agreement shall be
        binding upon and shall inure to the benefit of the parties, their
        successors and permitted assigns.
      </p>
    </div>
    <RightInfoPanel />
  </div>
</template>

<script>

import RightInfoPanel from "../components/RightInfoPanel";

export default {
  components: {
    RightInfoPanel,
  },

  methods: {
 
  },
};

</script>

<style scoped>
.ack {
  text-align: left;
  padding-bottom: 1vh;
  /*margin: 5vh;*/
  /*font-weight: bold;*/
}

.dakrlist {
  text-align: left;
  background: #cecece;
  padding-top: 1vh;
  padding-bottom: 1vh;
}

.list {
  /* padding-left: 15vh; */
  padding-right: 3vh;
  font-size: small;
}

@media (min-width: 950px) {
  .workspace-grid {
    display: grid;
    grid-template-columns: auto 340px;
  }
} 

</style>
